import { Box, Container, Divider, Flex, Grid, GridItem, Heading, Highlight, Icon, Image, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { BiEnvelope, BiTime } from 'react-icons/bi';

export default function FooterSales() {
    // Payment method logos - using placeholder images, replace with actual logos
    const paymentMethods = [
        { name: 'Mastercard', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg' },
        { name: 'Visa', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg' },
        { name: 'BCA', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Bank_Central_Asia.svg' },
        { name: 'Mandiri', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/Bank_Mandiri_logo_2016.svg' },
        { name: 'BNI', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Bank_Negara_Indonesia_logo_%282004%29.svg/500px-Bank_Negara_Indonesia_logo_%282004%29.svg.png?20250516061934' },
        { name: 'BRI', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/BRI_2020.svg' },
        { name: 'GoPay', logo: 'https://upload.wikimedia.org/wikipedia/commons/8/86/Gopay_logo.svg' },
        { name: 'OVO', logo: 'https://upload.wikimedia.org/wikipedia/commons/e/eb/Logo_ovo_purple.svg' },
        { name: 'QRIS', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Logo_QRIS.svg/330px-Logo_QRIS.svg.png?20230615062219' },
    ];

    return (
        <Box w='full' bg='gray.50' borderTop='1px' borderColor='gray.200' mt={20}>
            <Container maxW='7xl' py={12}>
                <Grid
                    templateColumns={{
                        base: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)',
                    }}
                    gap={8}
                    mb={8}>
                    {/* Customer Care Section */}
                    <GridItem>
                        <VStack align='start' spacing={4}>
                            <Heading size='md' fontWeight={600} color='gray.700'>
                                Customer Care
                            </Heading>
                            <VStack align='start' spacing={3}>
                                <Flex align='center' gap={3}>
                                    <Icon as={BiTime} fontSize='20px' color='primary.500' />
                                    <Text fontSize='sm' color='gray.600'>
                                        Business Hours : 09:00 - 19:00
                                    </Text>
                                </Flex>
                                {/* <Flex align='center' gap={3}>
                                    <Icon as={BiPhone} fontSize='20px' color='primary.500' />
                                    <Link href='tel:08041871871' fontSize='sm' color='gray.600' _hover={{ color: 'primary.500' }}>
                                        0804 1 871 871
                                    </Link>
                                </Flex> */}
                                <Flex align='center' gap={3}>
                                    <Icon as={BiEnvelope} fontSize='20px' color='primary.500' />
                                    <Link href='mailto:superpark.pim@dreamusgroup.com' fontSize='sm' color='gray.600' _hover={{ color: 'primary.500' }}>
                                        superpark.pim@dreamusgroup.com
                                    </Link>
                                </Flex>
                            </VStack>

                            {/* Social Media */}
                            {/* <Box pt={2}>
                                <Text fontSize='sm' fontWeight={600} color='gray.700' mb={3}>
                                    Follow Us
                                </Text>
                                <Flex gap={3}>
                                    <Link href='#' _hover={{ transform: 'translateY(-2px)', transition: 'all 0.2s' }}>
                                        <Icon as={FaFacebook} fontSize='20px' color='gray.500' _hover={{ color: 'primary.500' }} />
                                    </Link>
                                    <Link href='#' _hover={{ transform: 'translateY(-2px)', transition: 'all 0.2s' }}>
                                        <Icon as={FaTwitter} fontSize='20px' color='gray.500' _hover={{ color: 'primary.500' }} />
                                    </Link>
                                    <Link href='#' _hover={{ transform: 'translateY(-2px)', transition: 'all 0.2s' }}>
                                        <Icon as={FaInstagram} fontSize='20px' color='gray.500' _hover={{ color: 'primary.500' }} />
                                    </Link>
                                    <Link href='#' _hover={{ transform: 'translateY(-2px)', transition: 'all 0.2s' }}>
                                        <Icon as={FaYoutube} fontSize='20px' color='gray.500' _hover={{ color: 'primary.500' }} />
                                    </Link>
                                </Flex>
                            </Box> */}
                        </VStack>
                    </GridItem>

                    {/* Payment Methods Section */}
                    <GridItem colSpan={{ base: 1, lg: 2 }}>
                        <VStack align='start' spacing={4} w='full'>
                            <Heading size='md' fontWeight={600} color='gray.700'>
                                Payment Methods
                            </Heading>
                            <SimpleGrid columns={{ base: 4, md: 6, lg: 8 }} spacing={4} w='full'>
                                {paymentMethods.map((method, index) => (
                                    <Box
                                        key={index}
                                        bg='white'
                                        p={3}
                                        rounded='lg'
                                        border='1px'
                                        borderColor='gray.200'
                                        display='flex'
                                        alignItems='center'
                                        justifyContent='center'
                                        h='50px'
                                        transition='all 0.2s'
                                        _hover={{
                                            borderColor: 'primary.300',
                                            boxShadow: 'sm',
                                        }}>
                                        <Image src={method.logo} alt={method.name} maxH='30px' maxW='full' objectFit='contain' />
                                    </Box>
                                ))}
                            </SimpleGrid>
                        </VStack>
                    </GridItem>
                </Grid>

                <Divider my={6} />

                {/* Bottom Section - Legal & Copyright */}
                <Flex direction={{ base: 'column', md: 'row' }} justify='space-between' align='center' gap={4} pt={4}>
                    <Text fontSize='sm' color='gray.500' textAlign={{ base: 'center', md: 'left' }}>
                        © {new Date().getFullYear()} PT. DreamUs Edutainment Indonesia. All Rights Reserved.
                    </Text>

                    <Flex gap={6} flexWrap='wrap' justify='center'>
                        <Link href='/privacy-policy' fontSize='sm' color='gray.600' _hover={{ color: 'primary.500', textDecoration: 'underline' }}>
                            Privacy Policy
                        </Link>
                        {/* <Link href='#' fontSize='sm' color='gray.600' _hover={{ color: 'primary.500', textDecoration: 'underline' }}>
                            Cookie Policy
                        </Link> */}
                    </Flex>
                </Flex>

                {/* Powered By */}
                <Text fontSize='sm' color='gray.400' textAlign='center' mt={6} onClick={null}>
                    <Highlight query={['scap.co.id']} styles={{ color: 'blue.300', fontWeight: 600, cursor: 'pointer' }}>
                        Powered by scap.co.id
                    </Highlight>
                </Text>
            </Container>
        </Box>
    );
}
